import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAgendaSidebarCard = styled(Flexbox)<{$isSelected?: boolean}>(
    ({theme: {spacing, palette, shadows, transition}, $isSelected}) => css`
        padding: ${spacing * 2}px;
        background-color: ${palette.neutral['white']};
        border-radius: 8px;
        box-shadow: ${shadows.sm};
        outline: 1px solid ${palette.neutral['300']};
        transition: ${transition};
        ${$isSelected &&
        css`
            outline: 1px solid ${palette.primary['500']};
            box-shadow: ${`${shadows.sm}, 0px 0px 0px 4px ${palette.primary['100']}`};
        `}
    `
)

export const StyledAgendaSidebarCardTitle = styled.h3<{$isPointer?: boolean}>(
    ({theme: {palette, typography}, $isPointer}) => css`
        color: ${palette.neutral['600']};
        font-weight: 500;
        text-decoration: ${$isPointer ? 'underline' : 'none'};
        ${typography.textSm};
        ${$isPointer &&
        css`
            cursor: pointer;
        `}
    `
)
